// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  background-color: #f4f6f8;\n  height: 100%;\n}\n\na {\n  text-decoration: none;\n}\n\n#root {\n  height: 100%;\n}\n\n@media (max-width: 420px) {\n  .hide-on-mobile {\n    display: none !important;\n  }\n}", ""]);
// Exports
module.exports = exports;
